<template>
  <a-card
    title="查询"
    size="small"
    :headStyle="{
      background: '#f3f3f3',
    }"
  >
    <a-form layout="inline">
      <a-row>
        <a-col :span="8">
          <a-form-item labelAlign="left">
            创建时间
            <a-range-picker
              v-model:value="searchForm.orderDate"
              style="width: 250px"
              :placeholder="['', '']"
              valueFormat="YYYY-MM-DD"
              format="YYYY-MM-DD"
            /> </a-form-item
        ></a-col>
        <a-col :span="8">
          <a-form-item>
            打印状态
            <a-select
              style="width: 250px"
              v-model:value="searchForm.status"
              :labelInValue="true"
              placeholder="打印状态"
            >
              <a-select-option value="1">待打印</a-select-option>
              <a-select-option value="2">已打印</a-select-option>
              <a-select-option value="3">已作废</a-select-option>
              <a-select-option value="4">已取消</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item>
            物流状态
            <a-select
              style="width: 250px"
              v-model:value="searchForm.state"
              :labelInValue="true"
              placeholder="请选择"
            >
              <a-select-option value="1">待发货</a-select-option>
              <a-select-option value="2">已发货</a-select-option>
              <a-select-option value="3">已完成</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item>
            快递类型
            <a-select
              :labelInValue="true"
              style="width: 250px"
              v-model:value="searchForm.demand"
              placeholder="请选择"
            >
              <a-select-option value="1">顺丰</a-select-option>
              <a-select-option value="2">ems</a-select-option>
              <!-- <a-select-option value="3">ems转顺丰</a-select-option> -->
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item :labelAlign="left">
            <span>票号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <a-input
              style="width: 250px"
              v-model:value="searchForm.ticketcode"
              placeholder="请输入票号 "
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item>
            <span>订单号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <a-input
              style="width: 250px"
              v-model:value="searchForm.taskcode"
              placeholder="请输入订单号"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item>
            客人姓名
            <a-input
              style="width: 250px"
              v-model:value="searchForm.names"
              placeholder="请输入姓名"
            />
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item>
            快递单号
            <a-input
              style="width: 250px"
              v-model:value="searchForm.numbers"
              placeholder="请输入快递单号"
            />
          </a-form-item>
        </a-col>

        <a-col :span="8">
          <a-form-item>
            <span>手机号&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <a-input
              style="width: 250px"
              v-model:value="searchForm.receiptphone"
              placeholder="请输入手机号"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <div class="bt-sub">
        <a-form-item>
          <a-button type="primary" @click="searchAction"> 查询 </a-button>
        </a-form-item>

        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
      </div>
    </a-form>
  </a-card>
  <a-table
    bordered
    :scroll="{ x: 1300 }"
    :row-key="(r) => r.id"
    :pagination="false"
    :columns="columns"
    :dataSource="list"
    :rowKey="
      (record, index) => {
        return index;
      }
    "
  >
    <template v-slot:increase="{ text, record, index }">
      {{ index + 1 }}
    </template>
    <template v-slot:statusType="{ text, record }">
      {{
        record.status == "1"
          ? "待打印"
          : record.status == "2"
          ? "已打印"
          : record.status == "3"
          ? "已作废"
          : "已取消"
      }}
    </template>
    <template v-slot:expressstatus="{ text, record }">
      {{
        record.expressstatus == "1"
          ? "待发货"
          : record.expressstatus == "2"
          ? "已发货"
          : "已完成"
      }}
    </template>
    <template v-slot:disposeTerm="{ text, record }">
      {{
        record.term == "1" ? "1月以内" : record.term == "2" ? "1月-1年以内" : ""
      }}
    </template>
    <template v-slot:demand="{ text, record }">
      {{
        record.demand === 2 &&
        record.expressmodel == "顺丰快递" &&
        record.expressmodel != "无"
          ? "ems转" + record.expressmodel
          : record.expressmodel
      }}
    </template>
    <!-- 发送状态 -->
    <template v-slot:sendtype="{ text, record }">
      {{ record.sendtype == "1" ? "未发送" : "已发送" }}
    </template>
    <!-- 快递信息 -->
    <template v-slot:expressNum="{ text, record }">
      <p
        type="link"
        @click="
          showModal1(record);
          getExpressMsg(record.tripid);
        "
      >
        {{ record.numbers == "" ? "无" : record.numbers }}
      </p>
    </template>
    <!-- 快递信息 -->
    <template v-slot:collectMsg="{ text, record }">
      <a-button type="link" @click="showModal(record)"> 查看 </a-button>
    </template>
    <!-- 任务号ID -->
    <template v-slot:topTaskCode="{ text, record }">
      {{ taskcodeId }}
    </template>
    <!-- 打印类型 -->
    <template v-slot:printType="{ text, record }">
      {{ record.printtype == 0 ? "普通" : "中性" }}
    </template>
    <!-- 退单 -->
    <template v-slot:reason="{ text, record }" style="font-size: 12px">
      {{
        record.reason == 1
          ? "旅客申请退款，客服人工备注"
          : record.reason == 2
          ? "行程单已在其他渠道打印"
          : record.reason == 3
          ? "未授权打印"
          : record.reason == 4
          ? "客票异常，需联系出票方打印"
          : record.reason == 5
          ? "物流问题需退款"
          : "无"
      }}
      <!-- <div class="reason-text">
        <p>1.旅客申请退款，客服人工备注</p>
        <p>2.行程单已在其他渠道打印</p>
        <p>3.未授权打印</p>
        <p>4.客票异常，需联系出票方打印</p>
        <p>5.物流问题需退款</p>
      </div> -->
    </template>
    <template #orderType="{ text, record, index }"> 订单类型 </template>
    <template #sellMoney="{ text, record, index }"> 客票实际销售金额 </template>
    <template #printMoney="{ text, record, index }">行程单打印金额</template>
    <template #billLink="{ text, record, index }">差额发票链接</template>
  </a-table>
  <!-- address -->
  <a-modal v-model:visible="visible" title="收货地址" @ok="handleOk">
    <p>收件人姓名:{{ userInfo.name }}</p>
    <p>收件人电话:{{ userInfo.phone }}</p>
    <p>收件人地址:{{ userInfo.address }}</p>
    <template v-slot:footer>
      <a-button type="primary" @click="handleOk">关闭</a-button>
    </template>
  </a-modal>
  <a-modal
    v-model:visible="visible1"
    title="快递信息"
    :width="600"
    @cancel="handleOk1"
    cancelText="关闭"
  >
    <div class="user-info">
      <p>快递公司:{{ userInfo.address }}</p>
      <p>快件单号:{{ userInfo.numbers }}</p>
      <p>收件人姓名:{{ userInfo.name }}</p>
      <p>收件人电话:{{ userInfo.phone }}</p>
      <p>收件人地址:{{ userInfo.address }}</p>
    </div>
    <a-divider />
    <div>
      <div v-for="(item, index) in expressMsg" :key="index">
        <div style="padding: 10px">{{ item.time }}</div>
        <div style="padding: 10px">{{ item.context }}</div>
      </div>
    </div>

    <template v-slot:footer>
      <a-button type="primary" @click="handleOk1">关闭</a-button>
    </template>
  </a-modal>
  <df-pagination :model="pageObj"></df-pagination>
</template>

<script>
import orderApi from "@axios/order";
import { reactive, ref, provide } from "vue";
import { useRoute } from "vue-router";
export default {
  setup() {
    let route = useRoute();
    let markId = ref([]);
    let markCode = ref([]);
    //任务号
    let taskcodeId = ref("");
    taskcodeId.value = route.params.taskcode;
    // let taskid = JSON.parse(route.query.record);
    // let taskNum = JSON.parse(route.query.taskcode);
    // markId.value = taskid;
    // markCode.value = taskNum;
    // console.log(markCode);
    let userInfo = ref([]);
    let expressMsg = ref([]);
    let orderNumber = ref([]);
    let loading = ref(false);
    let showModal1 = (record) => {
      let { receiptaddress, receiptname, receiptphone, expressmodel, numbers } =
        record;
      getMessag(
        receiptname,
        receiptaddress,
        receiptphone,
        expressmodel,
        numbers
      );
      visible1.value = true;
      getExpressMsg(record.tripid);
    };
    let showModal = async (record) => {
      let { receiptaddress, receiptname, receiptphone, expressmodel, numbers } =
        record;
      getMessag(receiptname, receiptaddress, receiptphone, expressmodel),
        numbers;
      visible.value = true;
      getExpressMsg(record.tripid);
    };
    let getMessag = (name, address, phone, expressmodel, numbers) => {
      userInfo.value = { name, address, phone, expressmodel, numbers };
    };
    let getExpressMsg = async (id) => {
      await orderApi.getExpressMsg(id).then((res) => {
        orderNumber = res.orderNumber;
        expressMsg.value = res.data;
      });
    };
    const visible = ref(false);
    const visible1 = ref(false);
    const handleOk1 = (e) => {
      visible1.value = false;
    };
    const handleOk = (e) => {
      visible.value = false;
    };
    //分页
    let pageObj = ref({
      page: 1,
      rows: 10,
      totle: 1,
    });
    const pageChange = (page) => {
      pageObj.value.page = page;
      getList();
    };

    const onShowSizeChange = (current, pageSize) => {
      pageObj.value.page = 1;
      pageObj.value.rows = pageSize;
      getList();
    };

    let list = ref([]);
    //clone
    let arrList = ref([]);
    let searchAction = () => {
      searchParams.orderDate = searchForm.orderDate;
      searchParams.status = searchForm.status;
      searchParams.state = searchForm.state;
      searchParams.demand = searchForm.demand;
      searchParams.ticketcode = searchForm.ticketcode;
      searchParams.taskcode = searchForm.taskcode;
      searchParams.names = searchForm.names;
      searchParams.numbers = searchForm.numbers;
      searchParams.receiptphone = searchForm.receiptphone;
      pageObj.value = {
        page: 1,
        rows: 10,
        totle: 1,
      };
      getList();
    };

    provide("pageChange", pageChange);
    provide("onShowSizeChange", onShowSizeChange);
    let getList = async () => {
      loading.value = true;
      let params = {};
      if (searchParams.orderDate.length) {
        params.tripBeginTime = searchForm.orderDate[0]
          ? searchForm.orderDate[0]
          : "";
        params.tripEndTime = searchForm.orderDate[1]
          ? searchForm.orderDate[1]
          : "";
      }
      params.status = searchParams.status
        ? parseInt(searchParams.status.key)
        : null;
      params.expressstatus = searchParams.state ? searchParams.state.key : null;
      params.demand = searchParams.demand ? searchParams.demand.key : null;
      params.ticketcode = searchParams.ticketcode
        ? searchParams.ticketcode
        : null;
      params.taskcode = searchParams.taskcode ? searchParams.taskcode : null;
      params.names = searchParams.names ? searchParams.names : null;
      params.numbers = searchParams.numbers ? searchParams.numbers : null;
      params.receiptphone = searchParams.receiptphone
        ? searchParams.receiptphone
        : null;
      params.currentPage = pageObj.value.page;
      params.size = pageObj.value.rows;
      params.taskid = JSON.parse(route.params.id);
      // params.taskid = 877;
      await orderApi.getPlanePrint(params).then((res) => {
        loading.value = false;
        if (!res) return;
        pageObj.value.totle = res.total;
        pageObj.value.page = res.page;

        list.value = res.data;
        // }
      });
    };
    let reset = () => {
      searchForm.orderDate = [];
      searchForm.status = "";
      searchForm.state = "";
      searchForm.demand = "";
      searchForm.ticketcode = "";
      searchForm.taskcode = "";
      searchForm.names = "";
      searchForm.numbers = "";
      searchForm.receiptphone = "";
    };
    let searchForm = reactive({
      orderDate: [],
      status: "",
      state: "",
      demand: "",
      ticketcode: "",
      taskcode: "",
      names: "",
      numbers: "",
      receiptphone: "",
    });
    let searchParams = reactive({
      orderDate: [],
      status: "",
      state: "",
      demand: "",
      ticketcode: "",
      taskcode: "",
      names: "",
      numbers: "",
      receiptphone: "",
    });
    const formatEMSToSF = (v) => {
      switch (v) {
        case "EMS快递":
          return "EMS转SF";

        default:
          return v;
      }
    };
    //
    getList();
    return {
      arrList,
      taskcodeId,
      markCode,
      markId,
      reset,
      onShowSizeChange,
      pageObj,
      loading,
      orderNumber,
      expressMsg,
      userInfo,
      getExpressMsg,
      visible,
      visible1,
      showModal,
      showModal1,
      handleOk,
      handleOk1,
      list,
      searchAction,
      searchForm,
      searchParams,
      columns: [
        {
          title: "",
          width: 50,
          align: "center",
          slots: {
            customRender: "increase",
          },
        },
        {
          title: "ID",
          align: "center",
          width: 100,
          dataIndex: "tripid",
        },
        {
          title: "任务号",
          align: "center",
          width: 200,
          // dataIndex: "topTaskCode ",
          slots: {
            customRender: "topTaskCode",
          },
        },
        {
          title: "订单号",
          align: "center",
          width: 200,
          dataIndex: "taskcode",
        },
        {
          title: "票号",
          align: "center",
          width: 120,
          dataIndex: "ticketcode",
        },
        {
          title: "行程单号",
          align: "center",
          width: 150,
          dataIndex: "tripcode",
        },
        {
          title: "创建时间",
          align: "center",
          width: 150,
          dataIndex: "createtime",
        },
        {
          title: "打印状态",
          align: "center",
          width: 100,
          dataIndex: "status",
          slots: {
            customRender: "statusType",
          },
        },
        {
          title: "发送状态",
          align: "center",
          width: 100,
          dataIndex: "sendtype",
          slots: {
            customRender: "sendtype",
          },
        },
        {
          title: "处理时间",
          align: "center",
          width: 100,
          dataIndex: "handletime",
        },
        {
          title: "快递状态",
          align: "center",
          width: 100,
          dataIndex: "expressstatus",
          slots: {
            customRender: "expressstatus",
          },
        },
        {
          title: "收件信息",
          align: "center",
          width: 100,
          slots: {
            customRender: "collectMsg",
          },
        },
        {
          title: "快递公司",
          align: "center",
          width: 200,
          dataIndex: "demand",
          slots: {
            customRender: "demand",
          },
        },
        {
          title: "快递单号",
          align: "center",
          width: 200,
          slots: {
            customRender: "expressNum",
          },
        },
        {
          title: "office号",
          align: "center",
          width: 100,
          dataIndex: "unitcodeoffice",
        },
        {
          title: "打印类型",
          align: "center",
          width: 100,
          slots: {
            customRender: "printType",
          },
        },
        {
          title: "备注",
          algin: "center",
          width: 100,
          dataIndex: "remarks",
        },
        {
          title: "打印期限",
          algin: "center",
          width: 120,
          dataIndex: "term",
          slots: {
            customRender: "disposeTerm",
          },
        },
        {
          title: "退单原因",
          align: "center",
          width: 200,
          slots: {
            customRender: "reason",
          },
        },
        {
          title: "订单类型",
          align: "center",
          width: 200,
          slots: {
            customRender: "orderType",
          },
        },
        {
          title: "客票实际销售金额",
          align: "center",
          width: 200,
          slots: {
            customRender: "sellMoney",
          },
        },
        {
          title: "行程单打印金额",
          align: "center",
          width: 200,
          slots: {
            customRender: "printMoney",
          },
        },
        {
          title: "差额发票链接",
          align: "center",
          width: 200,
          slots: {
            customRender: "billLink",
          },
        },
      ],
      formatEMSToSF,
    };
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bt-sub {
  display: flex;
  justify-content: center;
}
.ant-form-item-label {
  text-align: left;
}
.user-info {
  p {
    margin: 0;
  }
}
.reason-text {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  align-items: flex-start;
  p {
    margin-bottom: 2px;
  }
}
</style>